import React from 'react'
import { ModalWindowFooter } from './components/modal-window-footer'
import { ModalWindowContainer } from './components/modal-window-container'
import { ModalWindowProps, ModalWindowSizeEnum } from './types'
import { ModalWindowHeader } from './components/modal-window-header'
import { ModalWindowBody } from './components/modal-window-body'

export const ModalWindow = ({
  isOpened = false,
  children,
  onClose,
  width = 700,
  size = ModalWindowSizeEnum.Medium,
  title,
  firstButtonProps,
  secondButtonProps,
  hideHeader = false,
}: ModalWindowProps) => {
  return (
    <ModalWindowContainer isOpened={isOpened} onClose={onClose} width={width}>
      <ModalWindowHeader size={size} onClose={onClose} hideHeader={hideHeader}>
        {title}
      </ModalWindowHeader>
      <ModalWindowBody size={size}>{children}</ModalWindowBody>
      <ModalWindowFooter
        size={size}
        firstButtonProps={firstButtonProps}
        secondButtonProps={secondButtonProps}
      />
    </ModalWindowContainer>
  )
}
